
import axios from 'axios'
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    code: '',
    codeOK: false,
    items: [],
    snackbar: false,
    snackbarText: '',
    file: ''
  }),

  methods: {
    checkCode () {
      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?getItems', { code: this.code })
        .then(response => {
          if (response.data?.status === 'Success' && 'items' in response.data) {
            this.codeOK = true
            this.items = response.data.items
          }
        })
      return true
    },

    saveAll () {
      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?saveItems', { code: this.code, items: this.items })
        .then((response) => {
          if (response.data?.status === 'Success') {
            this.snackbarText = 'Sikeres mentés!'
            this.snackbar = true
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    upload () {
      if (!this.file) return

      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('code', this.code)

      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?uploadItemsAsExcel', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data?.status === 'Success' && 'items' in response.data) {
            this.items = response.data.items
            this.snackbarText = 'Sikeres mentés!'
            this.snackbar = true
          }
        })
    }
  }
})
